export type CenterTopMode = "attendance" | "management";

export interface CenterTopManagementConfig {
  title: string;
  person1Role: string;
  person1Name: string;
  person2Role: string;
  person2Name: string;
}

export interface CenterTopConfig {
  mode: CenterTopMode;
  management: CenterTopManagementConfig;
}

export function createDefaultCenterTopConfig(): CenterTopConfig {
  return {
    mode: "attendance",
    management: {
      title: "管理人员",
      person1Role: "",
      person1Name: "",
      person2Role: "",
      person2Name: ""
    }
  };
}

function text(value: unknown, fallback = ""): string {
  return typeof value === "string" ? value : fallback;
}

export function normalizeCenterTopConfig(value: unknown): CenterTopConfig {
  const defaults = createDefaultCenterTopConfig();
  const candidate = value && typeof value === "object" ? value as Record<string, unknown> : {};
  const management = candidate.management && typeof candidate.management === "object"
    ? candidate.management as Record<string, unknown>
    : {};

  return {
    mode: candidate.mode === "management" ? "management" : "attendance",
    management: {
      title: text(management.title, defaults.management.title),
      person1Role: text(management.person1Role),
      person1Name: text(management.person1Name),
      person2Role: text(management.person2Role),
      person2Name: text(management.person2Name)
    }
  };
}
